import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import _ from 'lodash';
import { Icon, Modal } from '@seeqdev/qomponents';
import { PathComponents } from '@/utilities/PathComponents.atom';
import { FakeLink } from '@/core/FakeLink';

export interface AssetReplaceModalProps {
  onAssetSelection: (item: { id: string }) => void;
  onClose: () => void;
  selectedAsset: { id: string; name: string } | undefined;
  availableAssets: any[];
  likelySwapOuts: { id: string; name: string; disabled: boolean }[];
  size: 'sm' | 'lg';
}

export const AssetReplaceModal: React.FunctionComponent<AssetReplaceModalProps> = ({
  onAssetSelection,
  onClose,
  selectedAsset,
  availableAssets,
  likelySwapOuts,
  size,
}) => {
  const [showFullPaths, setShowFullPaths] = useState(_.uniqBy(likelySwapOuts, 'name').length < likelySwapOuts.length);
  const hasSelectedAsset = !!selectedAsset;

  const { t } = useTranslation();

  return (
    <Modal
      size={size}
      open={true}
      onClose={onClose}
      testId="assetReplaceModal"
      title={t('ASSET_REPLACE.TITLE')}
      hideSubmitButton={true}
      cancelButtonLabel={t('CANCEL')}>
      <div>
        <div className="pb10">
          {t('ASSET_REPLACE.PROMPT', {
            hasSelectedAsset,
            selectedAsset: selectedAsset?.name,
          })}
        </div>
        {t('SWAPS.SHOW_FULL_PATH')}
        <span className="ml5 pl5 pr5">
          {showFullPaths ? (
            <a className="force-link-color" onClick={() => setShowFullPaths(false)}>
              <Icon icon="fc-toggle-on" extraClassNames="mr4" large={true} />
              {t('CONFIGURATION.ON')}
            </a>
          ) : (
            <a className="force-link-color" onClick={() => setShowFullPaths(true)}>
              <Icon icon="fc-toggle-off" extraClassNames="mr4" large={true} />
              {t('CONFIGURATION.OFF')}
            </a>
          )}
        </span>
        {showFullPaths
          ? _.map(availableAssets, (asset) => (
              <div className="pl10 pb10" key={asset.id}>
                <PathComponents
                  asset={asset}
                  actionOnComponent={() => {
                    onClose();
                    onAssetSelection(asset);
                  }}
                />
              </div>
            ))
          : _.map(likelySwapOuts, (asset) => (
              <div className="pl10 pb10" key={asset.id}>
                <FakeLink
                  extraClassNames="stronger nowrap"
                  onClick={() => {
                    onClose();
                    onAssetSelection(asset);
                  }}>
                  {asset.name}
                </FakeLink>
              </div>
            ))}
      </div>
    </Modal>
  );
};
